/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Plan metal grouping (e.g. platinum, gold, silver, etc)
 */
export enum TierLevel {
  platinum = 'platinum',
  gold = 'gold',
  silver = 'silver',
  expanded_bronze = 'expanded_bronze',
  bronze = 'bronze',
  catastrophic = 'catastrophic',
  none = 'none',
}
